import React, { useContext, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import EpicTrades from "../Components/Home/EpicTrades/EpicTrades.component";
import TopTradersToWatch from "../Components/Home/TradersToWatch/TradersToWatch.component";
import TokensToWatch from "../Components/Home/TokensToWatch/TokensToWatch.component";
import TopBuyVolume from "../Components/Home/TopBuyVolume/TopBuyVolume.component";
import { WalletsContext } from "../state/context/wallets.context";
import { AuthContext } from "../state/context/auth.context";
import EpicTransfers from "../Components/Home/EpicTransfers/EpicTransfers.component";
import OdinBalance from '../Components/Analytics/OdinBalance.component';
import { useTheme as useCustomTheme } from '../contexts/ThemeContext.jsx';
import LiveTransfers from "../Components/Home/Transfers/LiveTransfers.component.jsx";
import PlatformCharts from "../Components/Home/PlatformCharts/PlatformCharts.component.jsx";
import OdinCanisterBalance from "../Components/Common/OdinBalance.component.jsx";

// import TrendingCard from "../Components/Home/TrendingTokens/TrendingCard.component";
// import TrendingTokens from "../Components/Home/TrendingTokens/TrendingTokens.component";
// import BtcBalance from "../Components/Home/BtcBalance/BtcBalance.component";

const HomePage = () => {
  const { isDarkMode } = useCustomTheme();

  const { getWallets, getWalletGroups } = useContext(WalletsContext);

  const { state } = useContext(AuthContext);
  const { isConnected } = state.user || {};

  useEffect(() => {
    if (isConnected) {
      getWallets();
      getWalletGroups();
    }
  }, [isConnected]
  );

  useEffect(() => {

  }, []);


  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        boxSizing: "border-box",
        px: { xs: 1.5, sm: 2.5 },
        py: { xs: 2, sm: 3 },
        overflowX: "hidden",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={9}>
          <Grid container spacing={2}>
            <Grid item md={12}>
              <Box
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(255, 255, 255, 0.01)"
                    : "rgba(0, 0, 0, 0.1)",
                  border: ".02px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  sx={{
                    minHeight: { xs: 320, md: 360 },
                    alignItems: "stretch",
                  }}
                >
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{
                        height: "100%",
                        paddingBottom: {
                          xs: "10px",
                          md: "0px",
                        },
                      }}
                    >
                      <TopBuyVolume height="100%" />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <PlatformCharts />
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item md={12}>
              <Grid container spacing={2}>
                <Grid item md={4} xs={12}>
                  <Box
                    sx={{
                      border: ".02px solid rgba(255, 255, 255, 0.2)",
                      borderRadius: "10px",
                      height: "100%",
                      padding: "10px",
                    }}
                  >
                    <TopTradersToWatch />
                  </Box>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Box
                    sx={{
                      border: ".02px solid rgba(255, 255, 255, 0.2)",
                      borderRadius: "10px",
                      height: "100%",
                      padding: "10px",
                    }}
                  >
                    <EpicTrades />
                  </Box>
                </Grid>
                <Grid item md={4} xs={12}>
                  <Box
                    sx={{
                      border: ".02px solid rgba(255, 255, 255, 0.2)",
                      borderRadius: "10px",
                      height: "100%",
                      padding: "10px",
                    }}
                  >
                    <EpicTransfers />
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            <Grid item md={12}>
              <Box
                sx={{
                  border: ".02px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "10px",
                  padding: "10px",
                  marginBottom: "10px",
                }}
              >
                <TokensToWatch />
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          md={3}
          sx={{
            maxHeight: { md: "100vh" },
          }}
        >
          <Grid container spacing={2} sx={{ height: "100%" }}>
            <Grid item xs={12}>
              <Box
                sx={{
                  border: ".02px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              >
                <OdinCanisterBalance />
              </Box>
            </Grid>
            <Grid item xs={12} sx={{ flex: 1, minHeight: { xs: "auto", md: 0 } }}>
              <Box
                sx={{
                  border: ".02px solid rgba(255, 255, 255, 0.2)",
                  borderRadius: "10px",
                  padding: "1px",
                  height: { md: "100%", xs: "auto" },
                  overflowY: "auto",
                  maxHeight: { xs: "none", md: "calc(100vh - 200px)" }, // adjust for header/other content
                  //hide the scrollbar
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                }}
              >
                <LiveTransfers />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );

};

export default HomePage;
